import AdminTagList from '@/client/components/admin/shared/lists/AdminTagList';
import AdminUserSearchNew from '@/client/components/admin/shared/search/AdminUserSearchNew';
import type { AssignmentFormData } from '../../../types/assignmentTypes';
import CreateSwitchContainer from '@/client/components/admin/create/shared/layout/CreateSwitchContainer';
import { Stack } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export default function AssignmentEscalationContactsForm() {
  const { t } = useTranslation();

  const { watch, setValue } = useFormContext<AssignmentFormData>();

  const { addEscalationContacts, settings } = watch();

  const { escalationContacts } = settings;

  useEffect(() => {
    if (!addEscalationContacts) {
      setValue('settings.escalationContacts', []);
    }
  }, [addEscalationContacts]);

  const selectDataFn = (selectData: any) => [
    {
      title: t('admin.assignments.settings.escalationContacts'),
      options: selectData.map((contact: any) => ({
        id: contact._id,
        name: contact.full_name,
      })),
    },
  ];

  const onCheckItemIsSelectedFn = (selectedItem: any) =>
    escalationContacts.some((contact: any) => contact.id === selectedItem.id);

  const onSelectedItemChange = (selectedItem: any) => {
    if (!selectedItem) {
      return;
    }

    const alreadySelected = onCheckItemIsSelectedFn(selectedItem);

    if (alreadySelected) {
      setValue(
        'settings.escalationContacts',
        escalationContacts.filter((contact: any) => contact.id !== selectedItem.id),
      );

      return;
    }

    setValue('settings.escalationContacts', [...escalationContacts, selectedItem]);
  };

  return (
    <Stack paddingTop={6}>
      <CreateSwitchContainer
        name="addEscalationContacts"
        label={t('admin.assignments.settings.escalationContacts.add')}
        helpText={t('admin.assignments.settings.escalationContacts.add.helpText')}
      />

      {addEscalationContacts && (
        <Stack>
          <AdminUserSearchNew
            placeholder={t('admin.assignments.settings.escalationContactSearch.placeholder')}
            onSelectedItemChange={onSelectedItemChange}
            onCheckItemIsSelectedFn={onCheckItemIsSelectedFn}
            selectDataFn={selectDataFn}
          />

          {escalationContacts && escalationContacts.length > 0 && (
            <AdminTagList
              items={escalationContacts}
              onRemove={(item: any) =>
                setValue(
                  'settings.escalationContacts',
                  escalationContacts.filter((contact: any) => contact.id !== item.id),
                )
              }
            />
          )}
        </Stack>
      )}
    </Stack>
  );
}
